export default "__VITE_ASSET__bed69510__"